/* unplugin-vue-components disabled */import { render } from "./QuizQuestionLabel.vue?vue&type=template&id=83bf1db8&scoped=true&ts=true"
import script from "./QuizQuestionLabel.vue?vue&type=script&lang=ts"
export * from "./QuizQuestionLabel.vue?vue&type=script&lang=ts"

import "./QuizQuestionLabel.vue?vue&type=style&index=0&id=83bf1db8&scoped=true&lang=scss"
import "./QuizQuestionLabel.vue?vue&type=style&index=1&id=83bf1db8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83bf1db8"]])

export default __exports__